var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temPerguntas
    ? _c(
        "div",
        _vm._b(
          { staticClass: "open-questions ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita"
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "question", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(" " + _vm._s(_vm.titulo) + " ")
              ]),
              _c(
                "span",
                { staticClass: "ia-block-card__meta open-questions__legenda" },
                [_vm._v(" " + _vm._s(_vm.legenda) + " ")]
              )
            ],
            1
          ),
          _c(
            "ul",
            { staticClass: "open-questions__lista" },
            _vm._l(_vm.itens, function(item) {
              return _c(
                "li",
                { key: item.chave, staticClass: "open-questions__item" },
                [_vm._v(_vm._s(item.texto))]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }